import type { AdminSession } from '@starkey/shared'

const STORAGE_KEY = 'starkey_admin_session'

export function getAdminSession() {
  const raw = window.localStorage.getItem(STORAGE_KEY)
  if (!raw) {
    return null
  }

  try {
    return JSON.parse(raw) as AdminSession
  } catch {
    return null
  }
}

export function setAdminSession(session: AdminSession) {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(session))
}

export function clearAdminSession() {
  window.localStorage.removeItem(STORAGE_KEY)
}
